// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-header {
    font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
    font-size: 60px;
    font-weight: bold;
}

.subpage-header {
    font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
    font-size: 40px;
    font-weight: normal;
    margin-top: 40px;
}

.cmn-copyright {
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    justify-content: center;
    font-size: 15px;
}

.cmn-link {
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    font-size: 16px;
}

.submit-btn {
    width: 100%;
    height: 40px; /* Same height as input fields */
    /* padding: 10px; */
    border-radius: 8px;
    font-size: 18px;
    font-weight: bold;
    cursor: pointer;
    transition: 0.3s;
    font-family: Arial, Helvetica, sans-serif;
    margin-top: 10px;
    background: black;
    color: white;
    backdrop-filter: "blur(10px)";
    -webkit-backdrop-filter: "blur(6px)";
    transition: "0.2s ease";
}
  
submit-btn:hover {
    background-color: #218838;
}

.text-header {
    font-family:Arial, Helvetica, sans-serif;
    font-size: 18px;
    align-self: "right";
    margin-top: 4px;
    margin-left: 10px;
    /* font-weight: lighter; */
}

.text-label {
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    cursor: pointer;
    font-size: 16px;
    align-self: "right";
    margin-top: 4px;
    margin-left: 10px;
    margin-right: 30px;
    font-weight: lighter;
}

.cmn-label {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 18px;
    margin-left: 15px;
    white-space: nowrap;
    transition: opacity 0.15s ease-in-out;
    opacity: 0;
  }

`, "",{"version":3,"sources":["webpack://./src/components/Pages/Styles/common-styles.css"],"names":[],"mappings":"AAAA;IACI,6EAA6E;IAC7E,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,6EAA6E;IAC7E,eAAe;IACf,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mJAAmJ;IACnJ,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,mJAAmJ;IACnJ,eAAe;AACnB;;AAEA;IAEI,WAAW;IACX,YAAY,EAAE,gCAAgC;IAC9C,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,yCAAyC;IACzC,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,6BAA6B;IAC7B,oCAAoC;IACpC,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,wCAAwC;IACxC,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,mJAAmJ;IACnJ,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,yCAAyC;IACzC,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IAEnB,qCAAqC;IAIrC,UAAU;EAHZ","sourcesContent":[".page-header {\n    font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;\n    font-size: 60px;\n    font-weight: bold;\n}\n\n.subpage-header {\n    font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;\n    font-size: 40px;\n    font-weight: normal;\n    margin-top: 40px;\n}\n\n.cmn-copyright {\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n    justify-content: center;\n    font-size: 15px;\n}\n\n.cmn-link {\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n    font-size: 16px;\n}\n\n.submit-btn {\n    border-radius: 10px;\n    width: 100%;\n    height: 40px; /* Same height as input fields */\n    /* padding: 10px; */\n    border-radius: 8px;\n    font-size: 18px;\n    font-weight: bold;\n    cursor: pointer;\n    transition: 0.3s;\n    font-family: Arial, Helvetica, sans-serif;\n    margin-top: 10px;\n    background: black;\n    color: white;\n    backdrop-filter: \"blur(10px)\";\n    -webkit-backdrop-filter: \"blur(6px)\";\n    transition: \"0.2s ease\";\n}\n  \nsubmit-btn:hover {\n    background-color: #218838;\n}\n\n.text-header {\n    font-family:Arial, Helvetica, sans-serif;\n    font-size: 18px;\n    align-self: \"right\";\n    margin-top: 4px;\n    margin-left: 10px;\n    /* font-weight: lighter; */\n}\n\n.text-label {\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n    cursor: pointer;\n    font-size: 16px;\n    align-self: \"right\";\n    margin-top: 4px;\n    margin-left: 10px;\n    margin-right: 30px;\n    font-weight: lighter;\n}\n\n.cmn-label {\n    font-family: Arial, Helvetica, sans-serif;\n    font-size: 18px;\n    margin-left: 15px;\n    white-space: nowrap;\n    opacity: 1;\n    transition: opacity 0.15s ease-in-out;\n  }\n\n .cmn-label {\n    opacity: 0;\n  }\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
